// extracted by mini-css-extract-plugin
module.exports = {"intercomSize":"joPHZqWJ","intercomWrap":"s8z4ljfA","intercom":"uJPNHQGd","colorAvatar":"mAdLjaMy","avatar":"t3nzwUct","hide":"Wdx9R8i6"};